import React from "react";
import { useTranslation } from "react-i18next";
import {
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import PaddingNotselected from "../../images/PaddingNotselected.svg";
import PaddingSelected from "../../images/PaddingSelected.svg";
import PaddingAllsidesblack from "../../images/PaddingAllsidesblack.svg";
import PaddingAllsidesblue from "../../images/PaddingAllsidesblue.svg";
import RadiusAllsidesblack from "../../images/RadiusAllsidesblack.svg";
import RadiusAllsidesblue from "../../images/RadiusAllsidesBlue.svg";
import RadiusonesideBlack from "../../images/RadiusonesideBlack.svg";
import RadiusonesideBlue from "../../images/RadiusonesideBlue.svg";
import "../../styles/components/RightPanel.scss";
import DownwardArrow from "../../images/DownwardArrow.svg";
import SideArrow from "../../images/SideArrow.svg";

export default function ButtonAndShape({
  selectedComponent,
  styles,
  handleClickSwatch,
  handleClickSwatchBorder,
  changeBorderStyle,
  borderStyle,
  borderStyles,
  borderWidth,
  setBorderWidth,
  changeBorderWidth,
  paddingTRBL,
  setPaddingTRBL,
  radiusTRBL,
  setRadiusTRBL,
  commonPadding,
  commonRadius,
  handlePadding,
  handleRadius,
  changeRadius,
  changePadding,
  handleChange,
  expanded,
  layerCompData,
  handleClickSwatchScrollbar,
  handleClickSwatchScrollbarThumbBg,
  borderRadius,
  handleChangeBorderRadius
}) {
  const { t } = useTranslation();
  const showBorderDropdown =
    selectedComponent?.componentType === "Button"
      ? "borderDropdown"
      : "borderDropdownShape";
  let locked =
    layerCompData[
      layerCompData.findIndex((selComp) => selComp.id === selectedComponent.id)
    ]?.componentStyles?.lockBoolean;

  const handleArrowKeyPressShape = (e) => {
    if (e.key === "ArrowUp") {
      e.preventDefault();
      setBorderWidth(borderWidth == 9999 ? borderWidth : ++borderWidth);
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setBorderWidth(borderWidth != 0 ? --borderWidth : borderWidth);
    }
  };
  const handleArrowKeyPressButton = (e) => {
    if (e.key === "ArrowUp") {
      e.preventDefault();
      setBorderWidth(borderWidth == 9999 ? borderWidth : ++borderWidth);
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setBorderWidth(borderWidth != 0 ? --borderWidth : borderWidth);
    }
  };

  const handleArrowKeyPressButtonRadius = (property, e) => {
    if (e.key === "ArrowUp") {
      e.preventDefault();
      let px = radiusTRBL[property].toString();
      px = px.substr(px.length - 2, px.length);
      if (px == "px") {
        let number = radiusTRBL[property].substr(
          0,
          radiusTRBL[property].length - 2
        );

        number = ++number;
        setRadiusTRBL((prevState) => ({
          ...prevState,
          [property]: number - 1 == 9999 ? radiusTRBL[property] : number + "px",
        }));
      } else {
        setRadiusTRBL((prevState) => ({
          ...prevState,
          [property]:
            radiusTRBL[property] == 9999
              ? radiusTRBL[property]
              : ++radiusTRBL[property],
        }));
      }
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      let px = radiusTRBL[property].toString();
      px = px.substr(px.length - 2, px.length);
      if (px == "px") {
        let number = radiusTRBL[property].substr(
          0,
          radiusTRBL[property].length - 2
        );

        number = --number;
        setRadiusTRBL((prevState) => ({
          ...prevState,
          [property]: number + 1 ? number + "px" : radiusTRBL[property],
        }));
      } else {
        setRadiusTRBL((prevState) => ({
          ...prevState,
          [property]: radiusTRBL[property]
            ? --radiusTRBL[property]
            : radiusTRBL[property],
        }));
      }
    }
  };

  const handleArrowKeyPressShapePadding = (property) => (e) => {
    if (e.key === "ArrowUp") {
      e.preventDefault();
      setPaddingTRBL((prevState) => ({
        ...prevState,
        [property]:
          paddingTRBL[property] == 9999
            ? paddingTRBL[property]
            : ++paddingTRBL[property],
      }));
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setPaddingTRBL((prevState) => ({
        ...prevState,
        [property]: paddingTRBL[property]
          ? --paddingTRBL[property]
          : paddingTRBL[property],
      }));
    }
  };

  const handleArrowKeyPressShapeRadius = (property, e) => {
    if (e.key === "ArrowUp") {
      e.preventDefault();
      setRadiusTRBL((prevState) => ({
        ...prevState,
        [property]:
          radiusTRBL[property] == 9999
            ? radiusTRBL[property]
            : ++radiusTRBL[property],
      }));
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setRadiusTRBL((prevState) => ({
        ...prevState,
        [property]: radiusTRBL[property]
          ? --radiusTRBL[property]
          : radiusTRBL[property],
      }));
    }
  };

  return (
    <>
      <hr className="hrtag" />
      <div className="accordion2 customAccordIcons1">
        <Accordion onChange={handleChange("panel1")}>
          <AccordionSummary
            expandIcon={
              expanded.panel1 !== true ? (
                <img src={SideArrow} alt="" className="img-fluid" />
              ) : (
                <img src={DownwardArrow} alt="" className="img-fluid" />
              )
            }
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography className="accord2-summary">
              <div className="textProps">
                <div className="text">
                  {selectedComponent?.componentType === "Button"
                    ? t("editorRightPanel.propertiesTabcontent.button")
                    : selectedComponent?.componentType === "Scrollbar"
                      ? t("editorRightPanel.propertiesTabcontent.scrollbarSetting")
                      : selectedComponent?.componentType === "Shape"
                        ? t("editorRightPanel.propertiesTabcontent.shape")
                        : ""}
                </div>
              </div>
            </Typography>
          </AccordionSummary>

          <AccordionDetails className="accordion2-details">
            <div className="bg-fill">
              <div className="swatch">
                {
                  <div
                    style={styles.buttonColor}
                    className="swatchBorder"
                    onClick={() => {
                      !locked && handleClickSwatch();
                    }}
                  ></div>
                }
              </div>

              <div className="fill-color">
                {selectedComponent?.componentType === "Button"
                  ? t("editorRightPanel.propertiesTabcontent.buttonFill")
                  : t("editorRightPanel.propertiesTabcontent.shapeFill")}
              </div>
            </div>
          </AccordionDetails>
          {selectedComponent?.componentType === "Scrollbar" && (
            <>
              <AccordionDetails className="accordion2-details">
                <div className="bg-fill">
                  <div className="swatch">
                    {
                      <div
                        style={styles.scrollbarThumb}
                        className="swatchBorder"
                        onClick={() => {
                          !locked && handleClickSwatchScrollbar();
                        }}
                      ></div>
                    }
                  </div>
                  <div className="fill-color">
                    {"Scroll Thumb Color"}
                  </div>
                </div>
              </AccordionDetails>
              <AccordionDetails className="accordion2-details">
                <div className="bg-fill">
                  <div className="swatch">
                    {
                      <div
                        style={styles.scrollbarThumbBg}
                        className="swatchBorder"
                        onClick={() => {
                          !locked && handleClickSwatchScrollbarThumbBg();
                        }}
                      ></div>
                    }
                  </div>
                  <div className="fill-color">
                    {"Scroll Track Background Color"}
                  </div>
                </div>
              </AccordionDetails>
              <div className="height-width" style={{ marginLeft: "30px", width: "100%" }}>
                <TextField
                  autoComplete="off"
                  title="Thumb Radius in px"
                  disabled={locked}
                  value={borderRadius}
                  onChange={(e) => { handleChangeBorderRadius(e) }}

                  size="small"
                  inputProps={{
                    style: {
                      width: "70px",
                      position: "relative",
                      bottom: "6px",
                      height: "20px",
                      marginBottom: "-15px",
                      fontSize: "11px",
                      color: "black",
                      textAlign: "center",
                    },
                  }}
                />
                <p>Thumb Radius in px</p>
              </div>
            </>
          )}
        </Accordion>
        {selectedComponent?.componentType !== "Scrollbar" && (<hr className="hr" />)}
        {/*   </div> */}
        {selectedComponent?.componentType !== "Scrollbar" && (
          <Accordion onChange={handleChange("panel2")}>
            <AccordionSummary
              expandIcon={
                expanded.panel2 === true ? (
                  <img src={DownwardArrow} alt="" className="img-fluid" />
                ) : (
                  <img src={SideArrow} alt="" className="img-fluid" />
                )
              }
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography className="accord2-summary">
                <div className="textProps">
                  <div className="text">BORDER</div>
                </div>
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="accordion2-details">
              <div className="borderFll">
                <div className="bg-fill">
                  <div className="swatch">
                    {
                      <div
                        style={styles.borderColor}
                        className="swatchBorder"
                        onClick={() => {
                          !locked && handleClickSwatchBorder();
                        }}
                      ></div>
                    }
                  </div>

                  <div className="fill-color">
                    {t("editorRightPanel.propertiesTabcontent.border")}
                  </div>
                </div>
                <div className="borderSizeType">
                  <div className="fontSizeItems">
                    <p style={{ marginTop: "4px" }}>Size</p>
                    <TextField
                      disabled={locked}
                      className="textFieldCustom3"
                      name="borderWidth"
                      value={borderWidth}
                      onChange={changeBorderWidth}
                      onKeyDown={(e) =>
                        selectedComponent?.componentType === "Button"
                          ? handleArrowKeyPressButton(e)
                          : handleArrowKeyPressShape(e)
                      }
                      onBlur={(e) => changeBorderWidth(e, "blur")}
                      size="small"
                      inputProps={{
                        style: {
                          width: "80px",
                          marginTop: "-14px",
                          marginBottom: "-15px",
                          fontSize: "11px",
                          color: "#928989",
                          textAlign: "center",
                        },
                      }}
                    />{" "}
                  </div>

                  {selectedComponent.textComponentType.addContent !==
                    "triangleShape" &&
                    selectedComponent.textComponentType.addContent !==
                    "polygonShape" &&
                    selectedComponent.textComponentType.addContent !==
                    "hexagonShape" && (
                      <div
                        className={
                          selectedComponent?.componentType === "Button"
                            ? "fontWeightItems select_boxbordersize"
                            : "fontWeightItems select_boxbordershapesize"
                        }
                      >
                        <select
                          disabled={locked}
                          className={showBorderDropdown}
                          onChange={changeBorderStyle}
                          value={borderStyle}
                        >
                          {borderStyles.map((borderstyleItem, id) => {
                            return (
                              <option key={id} value={borderstyleItem.toLowerCase()}>
                                {borderstyleItem}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    )}
                  {(selectedComponent.textComponentType.addContent ===
                    "triangleShape" ||
                    selectedComponent.textComponentType.addContent ===
                    "polygonShape" ||
                    selectedComponent.textComponentType.addContent ===
                    "hexagonShape") && (
                      <div className="fontWeightItems">
                        <div className=" borderstyleShape">
                          <TextField
                            disabled={locked}
                            className=""
                            name="shapeStyle"
                            value="Solid"
                            size="small"
                            inputProps={{
                              style: {
                                marginTop: "-14px",
                                marginBottom: "-15px",
                                fontSize: "11px",
                                color: "black",
                                textAlign: "center",
                              },
                            }}
                          />{" "}
                        </div>
                      </div>
                    )}
                </div>
                {(selectedComponent.componentType === "Button" ||
                  selectedComponent.textComponentType.addContent ===
                  "rectangleShape") && (
                    <div className="padding">
                      <div className="paddingRad" style={{
                        display: commonPadding ? "flex": "block"
                      }}>
                        <div className="rPImages">
                          <img
                            src={
                              commonPadding === true
                                ? PaddingSelected
                                : PaddingNotselected
                            }
                            alt="PaddingBox"
                            className="image-fluid"
                            onClick={() => {
                              !locked && handlePadding("common");
                            }}
                          />
                          <img
                            src={
                              commonPadding === false
                                ? PaddingAllsidesblue
                                : PaddingAllsidesblack
                            }
                            style={{ paddingLeft: "16px" }}
                            alt="PaddingEach pl-2"
                            onClick={() => {
                              !locked && handlePadding("each");
                            }}
                          />
                        </div>
                        <div className="padRadIps" style={{
                          left: commonPadding ? "15px": "-10px",
                          marginTop: commonPadding ? "0px": "30px",
                        }}>
                          <div className={!commonPadding && "padRadDiv"}>
                            {!commonPadding && <div className="trbl">T</div>}
                            <TextField
                              disabled={locked}
                              className="textFieldCustom txtfld"
                              name="paddingTop"
                              value={paddingTRBL.paddingTop}
                              onChange={changePadding}
                              onKeyDown={handleArrowKeyPressShapePadding(
                                "paddingTop"
                              )}
                              onBlur={(e) => changePadding(e, "blur")}
                              size="small"
                              inputProps={{
                                style: {
                                  width: "50px",
                                  marginTop: "-14px",

                                  marginBottom: "-15px",
                                  fontSize: "11px",
                                  color: "#928989",
                                  textAlign: "center",
                                },
                              }}
                            />{" "}
                          </div>
                          {!commonPadding && (
                            <>
                              <div className="padRadDiv">
                                <div className="trbl">R</div>
                                <TextField
                                  disabled={locked}
                                  className="textFieldCustom txtfld"
                                  name="paddingRight"
                                  value={paddingTRBL.paddingRight}
                                  onChange={changePadding}
                                  onKeyDown={handleArrowKeyPressShapePadding(
                                    "paddingRight"
                                  )}
                                  onBlur={(e) => changePadding(e, "blur")}
                                  size="small"
                                  inputProps={{
                                    style: {
                                      width: "50px",
                                      marginTop: "-14px",
                                      marginBottom: "-15px",
                                      fontSize: "11px",
                                      color: "#928989",
                                      textAlign: "center",
                                    },
                                  }}
                                />{" "}
                              </div>
                              <div className="padRadDiv">
                                <div className="trbl">B</div>
                                <TextField
                                  disabled={locked}
                                  className="textFieldCustom txtfld"
                                  name="paddingBottom"
                                  value={paddingTRBL.paddingBottom}
                                  onChange={changePadding}
                                  onKeyDown={handleArrowKeyPressShapePadding(
                                    "paddingBottom"
                                  )}
                                  onBlur={(e) => changePadding(e, "blur")}
                                  size="small"
                                  inputProps={{
                                    style: {
                                      width: "50px",
                                      marginTop: "-14px",
                                      marginBottom: "-15px",
                                      fontSize: "11px",
                                      color: "#928989",
                                      textAlign: "center",
                                    },
                                  }}
                                />{" "}
                              </div>
                              <div className="padRadDiv">
                                <div className="trbl">L</div>
                                <TextField
                                  disabled={locked}
                                  className="textFieldCustom txtfld"
                                  name="paddingLeft"
                                  value={paddingTRBL.paddingLeft}
                                  onKeyDown={handleArrowKeyPressShapePadding(
                                    "paddingLeft"
                                  )}
                                  onChange={changePadding}
                                  onBlur={(e) => changePadding(e, "blur")}
                                  size="small"
                                  inputProps={{
                                    style: {
                                      width: "50px",
                                      marginTop: "-14px",
                                      marginBottom: "-15px",
                                      fontSize: "11px",
                                      color: "#928989",
                                      textAlign: "center",
                                    },
                                  }}
                                />{" "}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      <p className="radiusLabel">Radius</p>
                      <div className="paddingRad mt-0" style={{
                        display: commonRadius ? "flex": "block"
                      }}>
                        <div className="rPImages">
                          <img
                            src={
                              !commonRadius
                                ? RadiusAllsidesblack
                                : RadiusAllsidesblue
                            }
                            alt="PaddingBox"
                            className="image-fluid"
                            onClick={() => {
                              !locked && handleRadius("common");
                            }}
                          />
                          <img
                            src={
                              commonRadius === true
                                ? RadiusonesideBlack
                                : RadiusonesideBlue
                            }
                            alt="PaddingEach pl-2"
                            style={{ paddingLeft: "16px" }}
                            onClick={() => {
                              !locked && handleRadius("each");
                            }}
                          />
                        </div>
                        <div className="padRadIps" style={{
                          left: commonRadius ? "15px": "-10px",
                          marginTop: commonRadius ? "0px": "20px",
                        }}>
                          <div>
                            {!commonRadius && <div className="trbl">TL</div>}
                            <TextField
                              disabled={locked}
                              className="textFieldCustom txtfld"
                              name="borderTopLeftRadius"
                              value={radiusTRBL.borderTopLeftRadius}
                              onChange={changeRadius}
                              onKeyDown={
                                selectedComponent?.componentType === "Button"
                                  ? (e) =>
                                    handleArrowKeyPressButtonRadius(
                                      "borderTopLeftRadius",
                                      e
                                    )
                                  : (e) =>
                                    handleArrowKeyPressShapeRadius(
                                      "borderTopLeftRadius",
                                      e
                                    )
                              }
                              onBlur={(e) => changeRadius(e, "blur")}
                              size="small"
                              inputProps={{
                                style: {
                                  width:
                                    selectedComponent?.componentType === "Button"
                                      ? "50px"
                                      : "50px",
                                  marginTop: "-14px",
                                  marginBottom: "-15px",
                                  fontSize: "11px",
                                  color: "#928989",
                                  textAlign: "center",
                                },
                              }}
                            />{" "}
                          </div>
                          {!commonRadius && (
                            <>
                              <div>
                                <div className="trbl">TR</div>
                                <TextField
                                  disabled={locked}
                                  className="textFieldCustom txtfld"
                                  name="borderTopRightRadius"
                                  value={radiusTRBL.borderTopRightRadius}
                                  onChange={changeRadius}
                                  onKeyDown={
                                    selectedComponent?.componentType === "Button"
                                      ? (e) =>
                                        handleArrowKeyPressButtonRadius(
                                          "borderTopRightRadius",
                                          e
                                        )
                                      : (e) =>
                                        handleArrowKeyPressShapeRadius(
                                          "borderTopRightRadius",
                                          e
                                        )
                                  }
                                  onBlur={(e) => changeRadius(e, "blur")}
                                  size="small"
                                  inputProps={{
                                    style: {
                                      width:
                                        selectedComponent?.componentType ===
                                          "Button"
                                          ? "50px"
                                          : "50px",
                                      marginTop: "-14px",
                                      marginBottom: "-15px",
                                      fontSize: "11px",
                                      color: "#928989",
                                      textAlign: "center",
                                    },
                                  }}
                                />{" "}
                              </div>
                              <div>
                                <div className="trbl">BL</div>
                                <TextField
                                  disabled={locked}
                                  className="textFieldCustom txtfld"
                                  name="borderBottomLeftRadius"
                                  value={radiusTRBL.borderBottomLeftRadius}
                                  onChange={changeRadius}
                                  onKeyDown={
                                    selectedComponent?.componentType === "Button"
                                      ? (e) =>
                                        handleArrowKeyPressButtonRadius(
                                          "borderBottomLeftRadius",
                                          e
                                        )
                                      : (e) =>
                                        handleArrowKeyPressShapeRadius(
                                          "borderBottomLeftRadius",
                                          e
                                        )
                                  }
                                  onBlur={(e) => changeRadius(e, "blur")}
                                  size="small"
                                  inputProps={{
                                    style: {
                                      width:
                                        selectedComponent?.componentType ===
                                          "Button"
                                          ? "50px"
                                          : "50px",
                                      marginTop: "-14px",
                                      marginBottom: "-15px",
                                      fontSize: "11px",
                                      color: "#928989",
                                      textAlign: "center",
                                    },
                                  }}
                                />{" "}
                              </div>
                              <div>
                                <div className="trbl">BR</div>
                                <TextField
                                  disabled={locked}
                                  className="textFieldCustom txtfld"
                                  name="borderBottomRightRadius"
                                  value={radiusTRBL.borderBottomRightRadius}
                                  onChange={changeRadius}
                                  onKeyDown={
                                    selectedComponent?.componentType === "Button"
                                      ? (e) =>
                                        handleArrowKeyPressButtonRadius(
                                          "borderBottomRightRadius",
                                          e
                                        )
                                      : (e) =>
                                        handleArrowKeyPressShapeRadius(
                                          "borderBottomRightRadius",
                                          e
                                        )
                                  }
                                  onBlur={(e) => changeRadius(e, "blur")}
                                  size="small"
                                  inputProps={{
                                    style: {
                                      width:
                                        selectedComponent?.componentType ===
                                          "Button"
                                          ? "50px"
                                          : "50px",
                                      marginTop: "-14px",
                                      marginBottom: "-15px",
                                      fontSize: "11px",
                                      color: "#928989",
                                      textAlign: "center",
                                    },
                                  }}
                                />{" "}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </AccordionDetails>
          </Accordion>
        )}
      </div>
      {selectedComponent?.componentType === "Button" ? (
        <hr className="hr" />
      ) : (
        ""
      )}
    </>
  );
}
